import React, { useState, useEffect } from 'react';
import { Query } from 'react-apollo';
import { withTheme } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import { GET_AVAILABILITY_TOKEN } from 'graphql/calendar';
import Spin from 'components/common/Spin';
import { API } from 'aws-amplify';

class CronofyEl extends React.Component {
  componentDidMount() {
    const { theme } = this.props;
    const scheduler = window.CronofyElements.SlotPicker({
      target_id: 'cronofy-element-slots',
      element_token: this.props.token,
      tzid: this.props.timezone,
      availability_query: {
        response_format: 'slots',
        max_results: 200,
        start_interval: {
          minutes: 5,
        },
        participants: [
          {
            required: 'all',
            members: this.props.participants.map((i) => ({
              sub: i.sub,
              managed_availability: true,
              availability_rule_ids: ['weadmit_hours'],
              buffer: i.buffer,
            })),
          },
        ],
        required_duration: { minutes: this.props.duration },
        available_periods: [this.props.availablePeriods],
      },
      styles: {
        colors: {
          primary: theme.palette.primary.main,
        },
        prefix: 'SlotPicker',
      },
      callback: this.props.onPick,
    });

    this.scheduler = scheduler;
  }
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.timezone !== this.props.timezone) {
      this.scheduler.update({ tzid: nextProps.timezone });
    }
    return false;
  }
 
  render() {
    return <div id="cronofy-element-slots" />;
  }
}

const SlotPicker = ({ onPick, userIds, ...otherProps }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [data, setData] = useState();

  useEffect(() => {
    getElementToken(userIds);
  }, [userIds]);

  const getElementToken = (users) => {
    setLoading(true);
    setError();
    API.post('api', '/calendar/element_token', {
      body: {
        user_ids: users,
      },
    }).then(
      (resp) => {
        setData(resp);
        setLoading(false);
      },
      (e) => {
        setError(e.message);
      },
    );
  }


  if (loading) return <Spin spinning linear />;
  if (error) return <Alert color={'error'}>{error}</Alert>;


  return (
    <div>
      <CronofyEl
        token={data.token}
        participants={data.participants}
        onPick={onPick}
        {...otherProps}
      />
    </div>
  )
}

export default withTheme(SlotPicker);
